/**
 * Strip markdown syntax from a string, leaving plain text only.
 * Used for SEO meta descriptions and structured-data answer fields
 * where raw markdown tokens (**, __, `, #, etc.) would leak through.
 */
export function stripMarkdown(value: string): string {
	return value
		.replace(/```[\s\S]*?```/g, "")
		.replace(/`([^`]+)`/g, "$1")
		.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
		.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
		.replace(/[*_~]+/g, "")
		.replace(/^>\s?/gm, "")
		.replace(/^#+\s*/gm, "")
		.replace(/^-{3,}$/gm, "")
		.replace(/\s+/g, " ")
		.trim();
}

const DEFAULT_MAX_LENGTH = 155;

/**
 * Strip markdown, take the first paragraph, and clamp to N chars.
 * Useful for generating meta descriptions from markdown bodies or
 * long FAQ answers.
 */
export function deriveMetaDescription(
	value: string,
	maxLength: number = DEFAULT_MAX_LENGTH,
): string {
	const firstParagraph = value.split(/\n\s*\n/, 1)[0] ?? "";
	const plain = stripMarkdown(firstParagraph);
	if (plain.length <= maxLength) return plain;
	return `${plain.slice(0, maxLength - 1).trimEnd()}…`;
}
